import Vue from 'vue';
import Glide from '@glidejs/glide';

Vue.component('tour-slider', {
    data() {
        return {
            currentSlide: 1,
            glideTourSlider: null
        }
    },

    mounted() {
        if (document.querySelector('.tour-slider') !== null) {
            this.initSlider();
        }
    },

    methods: {
        nextSlide() {
            this.glideTourSlider.go('>');
        },

        previousSlide() {
            this.glideTourSlider.go('<');
        },

        initSlider() {
            this.glideTourSlider = new Glide('.tour-slider', {
                type: 'carousel',
                startAt: 0,
                gap: 10,
                peek: 25,
                perView: 1,
            })

            this.glideTourSlider.on('move.after', (event) => {
                this.currentSlide = this.glideTourSlider.index + 1;
            });

            this.glideTourSlider.mount();

        },
    }
});
